module.exports = __webpack_public_path__ + "img/p24.5dd10e86.png";